import { z } from 'zod';

export namespace SearchApplications {
  export const RequestQueryParams = z.object({
    q: z.string(),
    exclude: z.array(z.coerce.number()).optional(),
    typeId: z.coerce.number().optional(),
  });
  export type RequestQueryParams = z.infer<typeof RequestQueryParams>;

  export const ResponseBody = z.object({
    applications: z.array(z.object({
      id: z.number(),
      identifier: z.string(),
      name: z.string(),
    })),
  });
  export type ResponseBody = z.infer<typeof ResponseBody>;
}

export namespace SearchBrands {
  export const RequestQueryParams = z.object({
    q: z.string().optional(),
    exclude: z.array(z.coerce.number()).optional(),
    groupId: z.coerce.number().nullable(),
    take: z.coerce.number().prefault(10).optional(),
  });
  export type RequestQueryParams = z.infer<typeof RequestQueryParams>;

  export const ResponseBody = z.object({
    brands: z.array(z.object({
      id: z.number(),
      identifier: z.string(),
      name: z.string(),
    })),
  });
  export type ResponseBody = z.infer<typeof ResponseBody>;
}

export namespace SearchAgents {
  export const requestQueryParams = z.object({
    q: z.string(),
    exclude: z.array(z.coerce.number()).optional(),
  });

  export const responseBody = z.object({
    agents: z.array(z.object({
      id: z.coerce.number(),
      name: z.string(),
    })),
  });

  export type Request = z.infer<typeof requestQueryParams>;

  export type Response = z.infer<typeof responseBody>;
}

export namespace SearchApplications {
  export const requestQueryParams = z.object({
    q: z.string().optional(),
    exclude: z.array(z.coerce.number()).optional(),
  });

  export const responseBody = z.object({
    items: z.array(z.object({
      id: z.coerce.number(),
      name: z.string(),
    })),
  });

  export type Request = z.infer<typeof requestQueryParams>;

  export type Response = z.infer<typeof responseBody>;
}

export namespace SearchAccounts {
  export const requestQueryParams = z.void();

  export const responseBody = z.object({
    items: z.array(z.object({
      id: z.coerce.number(),
      name: z.string(),
    })),
  });

  export type Request = z.infer<typeof requestQueryParams>;

  export type Response = z.infer<typeof responseBody>;
}

export namespace SearchPermissions {
  export const requestQueryParams = z.void();

  export const responseBody = z.object({
    items: z.array(z.object({
      id: z.coerce.number(),
      name: z.string(),
      description: z.string(),
    })),
  });

  export type Request = z.infer<typeof requestQueryParams>;

  export type Response = z.infer<typeof responseBody>;
}

export namespace SearchUsers {
  export const requestQueryParams = z.object({
    groupId: z.coerce.number(),
    q: z.string(),
    exclude: z.array(z.coerce.number()).optional(),
  });

  export const responseBody = z.object({
    items: z.array(z.object({
      id: z.coerce.number(),
      name: z.string(),
      email: z.string().nullable(),
    })),
  });

  export type Request = z.infer<typeof requestQueryParams>;

  export type Response = z.infer<typeof responseBody>;
}

export namespace SearchDataSources {
  export const requestQueryParams = z.object({
    q: z.string().optional(),
    exclude: z.array(z.coerce.number()).optional(),
  });

  export const responseBody = z.object({
    dataSources: z.array(z.object({
      id: z.coerce.number(),
      identifier: z.string(),
      name: z.string(),
    })),
  });

  export type Request = z.infer<typeof requestQueryParams>;

  export type Response = z.infer<typeof responseBody>;
}

export namespace SearchChatContexts {
  export const requestQueryParams = z.object({
    q: z.string(),
    exclude: z.array(z.coerce.number()).optional(),
  });

  export const responseBody = z.object({
    items: z.array(z.object({
      id: z.coerce.number(),
      name: z.string(),
    })),
  });

  export type Request = z.infer<typeof requestQueryParams>;

  export type Response = z.infer<typeof responseBody>;
}

export const searchManagedSecretsRequestQueryParamsSchema = z.object({
  q: z.string(),
  exclude: z.array(z.coerce.number()).optional(),
});
export type SearchManagedSecretsRequestQueryParams = z.infer<typeof searchManagedSecretsRequestQueryParamsSchema>;

export const searchManagedSecretsResponseBodySchema = z.object({
  items: z.array(z.object({
    id: z.coerce.number(),
    identifier: z.string(),
    name: z.string(),
  })),
});

export const searchConnectedAppsRequestQueryParamsSchema = z.object({
  q: z.string(),
  exclude: z.array(z.coerce.number()).optional(),
});
export type SearchConnectedAppsRequestQueryParams = z.infer<typeof searchConnectedAppsRequestQueryParamsSchema>;

export const searchConnectedAppsResponseBodySchema = z.object({
  items: z.array(z.object({
    id: z.coerce.number(),
    identifier: z.string(),
    name: z.string(),
  })),
});